
import { defineComponent, SetupContext, computed } from "vue";

export default defineComponent({
  name: "DetailFooterView",
  props: {
    note: {
      type: String
    }
  },
  setup(props) {
    return {
    };
  }
});
